"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const list_export_settings_model_1 = require("./list-export-settings.model");
/**
 * Created by aghavni.grigoryan on 9/13/2017.
 */
class ListOptions {
    constructor() {
        this.listExportSettings = new list_export_settings_model_1.ListExportSettings();
    }
    get listExportSettings() {
        return this._listExportSettings;
    }
    set listExportSettings(exportSettings) {
        this._listExportSettings = exportSettings;
    }
    setListExportSettings(listExportSettings) {
        this.listExportSettings = this.listExportSettings === null ? this.listExportSettings : new list_export_settings_model_1.ListExportSettings();
        listExportSettings !== undefined && this.listExportSettings.fromJson(listExportSettings);
    }
    toJsonString() {
        let toJsonData = "";
        toJsonData += "{";
        toJsonData += "\"listExportSettings\":";
        toJsonData += this.listExportSettings.toJsonString();
        toJsonData += "}";
        return toJsonData;
    }
    fromJson(listSettings) {
        listSettings !== undefined && listSettings.listExportSettings !== undefined && this.setListExportSettings(listSettings.listExportSettings);
    }
}
exports.ListOptions = ListOptions;
//# sourceMappingURL=list-options.model.js.map